export default __webpack_public_path__ + "static/media/icon2.ff8b43f7.png";